(function () {
  function initStickyPurchase() {
    const sticky = document.querySelector("[data-pdp-sticky-purchase]");
    const mainActions = document.querySelector(".kuuraii-proto .product-actions, .kuuraii-proto .millet-pdp__form, .kuuraii-proto .vv-pdp__purchase-row");
    if (!sticky || !mainActions) return;

    const stickyVariantInput = sticky.querySelector("[data-sticky-variant-input]");
    const stickyPrice = sticky.querySelector("[data-sticky-product-price]");
    const stickyButton = sticky.querySelector("[data-sticky-add-to-cart]");
    const stickyButtonLabel = sticky.querySelector("[data-sticky-add-to-cart-label]");
    const stickyVariantOptions = Array.from(sticky.querySelectorAll("[data-sticky-variant-option]"));
    const stickyQuantityInput = sticky.querySelector("[data-sticky-quantity-input]");
    const stickyPreorderProperty = sticky.querySelector("[data-sticky-preorder-property]");
    const mainVariantButtons = Array.from(document.querySelectorAll(".kuuraii-proto [data-variant-button]"));
    const mainQuantityInput = mainActions.closest("form")?.querySelector(".product-quantity__input[name='quantity']");

    function syncStickyVariantState(button) {
      if (stickyVariantInput) stickyVariantInput.value = button.dataset.variantId || "";
      if (stickyPrice) stickyPrice.textContent = button.dataset.variantPrice || "";
      const variantLabel = (button.dataset.variantDetail || button.textContent || "").trim();
      stickyVariantOptions.forEach(function (option) {
        const active = option.dataset.variantId === button.dataset.variantId;
        option.classList.toggle("is-active", active);
        option.setAttribute("aria-checked", String(active));
      });
      if (stickyButton) {
        const available = button.dataset.variantAvailable === "true";
        const preorder = button.dataset.variantPreorder === "true";
        const buttonLabel = preorder ? "Pre-order now" : available ? "Add to cart" : "Sold out";
        stickyButton.disabled = !available && !preorder;
        if (stickyButtonLabel && stickyButtonLabel.isConnected) {
          stickyButtonLabel.textContent = buttonLabel;
        } else {
          stickyButton.textContent = buttonLabel;
        }
        stickyButton.setAttribute("aria-label", variantLabel ? buttonLabel + " - " + variantLabel : buttonLabel);
        if (stickyPreorderProperty) {
          stickyPreorderProperty.disabled = !preorder;
        }
      }
    }

    mainVariantButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        syncStickyVariantState(button);
      });
    });

    stickyVariantOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        const matchingMainButton = mainVariantButtons.find(function (button) {
          return button.dataset.variantId === option.dataset.variantId;
        });
        if (matchingMainButton) {
          matchingMainButton.click();
        } else {
          syncStickyVariantState(option);
        }
      });
    });

    function syncQuantity(source, target) {
      if (!source || !target) return;
      const nextValue = source.value || source.min || "1";
      if (target.value !== nextValue) {
        target.value = nextValue;
        target.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (stickyQuantityInput && mainQuantityInput) {
      mainQuantityInput.addEventListener("change", function () {
        syncQuantity(mainQuantityInput, stickyQuantityInput);
      });
      stickyQuantityInput.addEventListener("change", function () {
        syncQuantity(stickyQuantityInput, mainQuantityInput);
      });
    }

    function setStickyVisibility(shouldShow) {
      sticky.classList.toggle("is-visible", shouldShow);
      sticky.setAttribute("aria-hidden", String(!shouldShow));
    }

    function syncStickyVisibility() {
      const rect = mainActions.getBoundingClientRect();
      setStickyVisibility(rect.bottom < 0);
    }

    function syncPreviewBarOffset() {
      const previewBar = document.getElementById("PBarNextFrameWrapper");
      const previewBarHeight = previewBar ? previewBar.getBoundingClientRect().height : 0;
      sticky.style.bottom = previewBarHeight > 0 ? previewBarHeight + "px" : "";
    }

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        setStickyVisibility(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0.05 });

      observer.observe(mainActions);
    }

    window.addEventListener("scroll", syncStickyVisibility, { passive: true });
    window.addEventListener("resize", function () {
      syncStickyVisibility();
      syncPreviewBarOffset();
    });
    window.requestAnimationFrame(function () {
      syncStickyVisibility();
      syncPreviewBarOffset();
    });
    window.setTimeout(syncPreviewBarOffset, 1200);
  }

  function initCategoryStreams() {
    document.querySelectorAll("[data-category-stream-grid]").forEach(function (grid) {
      const cards = Array.from(grid.querySelectorAll("[data-category-stream-card]"));
      const sentinel = grid.parentElement.querySelector("[data-category-stream-sentinel]");
      if (!cards.length || !sentinel) return;

      const batchSize = window.matchMedia("(max-width: 749px)").matches ? 4 : 8;
      let visibleCount = 0;
      let observer = null;

      grid.classList.add("is-enhanced");
      cards.forEach(function (card) {
        card.hidden = true;
      });

      function revealNextBatch() {
        cards.slice(visibleCount, visibleCount + batchSize).forEach(function (card) {
          card.hidden = false;
        });
        visibleCount = Math.min(visibleCount + batchSize, cards.length);
        if (visibleCount >= cards.length) {
          sentinel.hidden = true;
          if (observer) observer.disconnect();
        }
      }

      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) revealNextBatch();
      }, { rootMargin: "320px 0px" });

      revealNextBatch();
      if (visibleCount < cards.length) observer.observe(sentinel);
    });
  }

  function initDetailReadMore() {
    document.querySelectorAll("[data-read-more]").forEach(function (container) {
      const copy = container.querySelector("[data-read-more-text]");
      const toggle = container.querySelector("[data-read-more-toggle]");
      if (!copy || !toggle) return;

      container.classList.add("is-enhanced");

      window.requestAnimationFrame(function () {
        if (copy.scrollHeight <= copy.clientHeight + 2) {
          container.classList.remove("is-enhanced");
          return;
        }

        toggle.addEventListener("click", function () {
          const expanded = container.classList.toggle("is-expanded");
          toggle.setAttribute("aria-expanded", String(expanded));
          toggle.textContent = expanded ? "Read less" : "Read more";
        });
      });
    });

    document.querySelectorAll("[data-detail-copy]").forEach(function (container) {
      const copy = container.querySelector("[data-detail-copy-text]");
      const toggle = container.querySelector("[data-detail-copy-toggle]");
      if (!copy || !toggle) return;

      const fullHeight = copy.scrollHeight;
      container.classList.add("is-enhanced");

      window.requestAnimationFrame(function () {
        if (fullHeight <= copy.clientHeight + 2) {
          container.classList.remove("is-enhanced");
          return;
        }

        toggle.addEventListener("click", function () {
          const expanded = container.classList.toggle("is-expanded");
          toggle.setAttribute("aria-expanded", String(expanded));
          toggle.textContent = expanded ? "Read less" : "Read more";
        });
      });
    });
  }

  function initMakingVideoControls() {
    document.querySelectorAll(".kuuraii-proto .making-video").forEach(function (wrap) {
      const video = wrap.querySelector("video");
      const button = wrap.querySelector("[data-making-video-play]");
      if (!video || !button) return;

      function setPlayingState(isPlaying) {
        wrap.classList.toggle("is-playing", isPlaying);
        button.setAttribute("aria-pressed", String(isPlaying));
        button.setAttribute("aria-label", isPlaying ? "Pause making video" : "Play making video");
      }

      button.addEventListener("click", function () {
        if (video.paused || video.ended) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function () {
              setPlayingState(false);
            });
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener("play", function () {
        setPlayingState(true);
      });

      video.addEventListener("pause", function () {
        setPlayingState(false);
      });

      video.addEventListener("ended", function () {
        setPlayingState(false);
      });
    });
  }

  function initBeddingStoryVideos() {
    function ensureVideoLoaded(v) {
      if (!v || v.dataset.loaded === "true") return;
      if (window.KuuraiiLazyMedia && typeof window.KuuraiiLazyMedia.loadVideo === "function") {
        window.KuuraiiLazyMedia.loadVideo(v);
        return;
      }
      const sources = v.querySelectorAll("source[data-src]");
      if (sources.length > 0) {
        sources.forEach(function (s) {
          s.src = s.dataset.src;
          s.removeAttribute("data-src");
        });
        v.load();
      } else if (v.dataset.src) {
        v.src = v.dataset.src;
        v.removeAttribute("data-src");
        v.load();
      }
      v.dataset.loaded = "true";
    }

    document.querySelectorAll(".kuuraii-proto--bedding-product .bedding-artisan-story__media, .kuuraii-proto--bedding-product .bedding-inline-video").forEach(function (wrap) {
      const video = wrap.querySelector("video");
      const playButton = wrap.querySelector("[data-bedding-story-play]");
      if (!video) return;
      if (wrap.dataset.beddingStoryVideoBound === "true") return;

      wrap.dataset.beddingStoryVideoBound = "true";
      wrap.tabIndex = 0;
      wrap.setAttribute("role", "button");
      wrap.setAttribute("aria-label", "Play or pause artisan story video");

      const isArtisanStory = wrap.classList.contains("bedding-artisan-story__media");

      function updateGlobalArtisanFlag() {
        const anyPlaying = Array.from(document.querySelectorAll(".bedding-artisan-story__media video")).some(function (v) {
          return !v.paused && !v.ended;
        });
        if (anyPlaying) {
          document.body.dataset.artisanStoryPlaying = "true";
        } else {
          delete document.body.dataset.artisanStoryPlaying;
        }
      }

      function setPlayingState(isPlaying) {
        wrap.classList.toggle("is-playing", isPlaying);
        wrap.setAttribute("aria-label", isPlaying ? "Pause artisan story video" : "Play artisan story video");
        if (playButton) {
          playButton.hidden = isPlaying;
          playButton.setAttribute("aria-label", isPlaying ? "Pause artisan story video" : "Play artisan story video");
        }
        if (isArtisanStory) {
          updateGlobalArtisanFlag();
        }
      }

      function toggleStoryVideo() {
        ensureVideoLoaded(video);

        if (video.paused || video.ended) {
          document.querySelectorAll("video").forEach(function (otherVideo) {
            if (otherVideo !== video && !otherVideo.paused) {
              otherVideo.pause();
            }
          });

          if (isArtisanStory) {
            document.body.dataset.artisanStoryPlaying = "true";
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function (err) {
              console.warn("Artisan video playback failed unmuted, trying muted fallback:", err);
              video.muted = true;
              video.play().catch(function () {
                setPlayingState(false);
                if (isArtisanStory) updateGlobalArtisanFlag();
              });
            });
          }
        } else {
          video.pause();
          setPlayingState(false);
        }
      }

      wrap.addEventListener("click", function (event) {
        if (event.target.closest("a") || event.target.closest("[data-video-sound-toggle]")) return;
        event.preventDefault();
        event.stopPropagation();
        toggleStoryVideo();
      });

      wrap.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (event.target.closest("[data-video-sound-toggle]")) return;
        event.preventDefault();
        toggleStoryVideo();
      });

      video.addEventListener("play", function () {
        setPlayingState(true);
      });

      video.addEventListener("pause", function () {
        setPlayingState(false);
      });

      video.addEventListener("ended", function () {
        setPlayingState(false);
      });
    });
  }

  function initProductMobileDots() {
    document.querySelectorAll(".kuuraii-proto [data-product-root]").forEach(function (root) {
      const rail = root.querySelector("[data-product-mobile-gallery]");
      const dotsWrap = root.querySelector("[data-product-mobile-dots]");
      if (!rail || !dotsWrap) return;
      if (rail.dataset.mobileDotsBound === "true") return;

      const slides = Array.from(rail.querySelectorAll(".product-mobile-media__slide"));
      const dots = Array.from(dotsWrap.querySelectorAll("span"));
      if (slides.length < 2 || dots.length < 2) return;

      rail.dataset.mobileDotsBound = "true";

      function nearestIndex() {
        return slides.reduce(function (nearest, slide, index) {
          return Math.abs(slide.offsetLeft - rail.scrollLeft) < Math.abs(slides[nearest].offsetLeft - rail.scrollLeft) ? index : nearest;
        }, 0);
      }

      function updateDots() {
        const activeIndex = nearestIndex();
        dots.forEach(function (dot, index) {
          dot.classList.toggle("is-active", index === activeIndex);
        });
      }

      updateDots();
      rail.addEventListener("scroll", function () {
        window.clearTimeout(rail.mobileDotsTimer);
        rail.mobileDotsTimer = window.setTimeout(updateDots, 90);
      }, { passive: true });
    });
  }

  function initBeddingAutoRails() {
    document.querySelectorAll("[data-bedding-auto-rail]").forEach(function (rail) {
      const slides = Array.from(rail.children);
      const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      let currentIndex = 0;
      let pauseUntil = 0;

      if (slides.length < 2 || reducedMotion) return;

      function nearestIndex() {
        return slides.reduce(function (nearest, slide, index) {
          return Math.abs(slide.offsetLeft - rail.scrollLeft) < Math.abs(slides[nearest].offsetLeft - rail.scrollLeft) ? index : nearest;
        }, 0);
      }

      function scrollToSlide(index) {
        currentIndex = (index + slides.length) % slides.length;
        rail.scrollTo({
          left: slides[currentIndex].offsetLeft,
          behavior: "smooth"
        });
      }

      function pauseBriefly() {
        pauseUntil = Date.now() + 4000;
        currentIndex = nearestIndex();
      }

      rail.addEventListener("pointerdown", pauseBriefly, { passive: true });
      rail.addEventListener("touchstart", pauseBriefly, { passive: true });
      rail.addEventListener("focusin", pauseBriefly);
      rail.addEventListener("scroll", function () {
        window.clearTimeout(rail.beddingScrollSyncTimer);
        rail.beddingScrollSyncTimer = window.setTimeout(function () {
          currentIndex = nearestIndex();
        }, 120);
      }, { passive: true });

      rail.beddingAutoTimer = window.setInterval(function () {
        const isVideoPlaying = slides.some(function (slide) {
          const video = slide.querySelector("video");
          return video && !video.paused && !video.ended;
        });
        if (isVideoPlaying) return;
        if (document.hidden || Date.now() < pauseUntil) return;
        scrollToSlide(currentIndex + 1);
      }, 1800);
    });
  }

  function initReviewsAnchorScroll() {
    function getStickyHeaderHeight() {
      const header = document.querySelector(".site-header, sticky-header, .header-wrapper, header");
      let h = header ? header.offsetHeight : 0;
      if (!h || h < 40) {
        const rootH = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10);
        h = !isNaN(rootH) && rootH > 0 ? rootH : 80;
      }
      return h;
    }

    function scrollToReviewsTarget(smooth) {
      const reviewsEl = document.getElementById("judgeme_product_reviews") ||
                        document.querySelector(".jdgm-widget, .jdgm-review-widget");
      if (!reviewsEl) return false;

      const section = reviewsEl.closest(".shopify-section, section") || reviewsEl;

      // Reveal any hidden lazy-rendered cards in category streams above the reviews section
      // so the page height does not shift unexpectedly during or after scrolling down.
      document.querySelectorAll("[data-category-stream-grid]").forEach(function (grid) {
        grid.querySelectorAll("[data-category-stream-card][hidden]").forEach(function (card) {
          card.hidden = false;
        });
        const sentinel = grid.parentElement ? grid.parentElement.querySelector("[data-category-stream-sentinel]") : null;
        if (sentinel) sentinel.hidden = true;
      });

      window.requestAnimationFrame(function () {
        const headerH = getStickyHeaderHeight();
        const rect = section.getBoundingClientRect();
        const targetY = Math.max(0, rect.top + window.pageYOffset - headerH - 10);

        window.scrollTo({
          top: targetY,
          behavior: smooth ? "smooth" : "auto"
        });
      });
      return true;
    }

    document.addEventListener("click", function (e) {
      const link = e.target.closest('a[href="#judgeme_product_reviews"], a[href$="#judgeme_product_reviews"]');
      if (!link) return;

      if (scrollToReviewsTarget(true)) {
        e.preventDefault();
        try {
          history.pushState(null, "", "#judgeme_product_reviews");
        } catch (err) {}
      }
    });

    if (window.location.hash === "#judgeme_product_reviews") {
      window.addEventListener("load", function () {
        setTimeout(function () {
          scrollToReviewsTarget(false);
        }, 350);
      });
    }
  }

  
  function initWhatsAppOffset() {
    function adjust() {
      if (window.innerWidth > 900) return;
      var wa = document.getElementById('bob_whatsapp_widget_container') || document.querySelector('[id*="bob_whatsapp"], .elfsight-app-whatsapp, #wa-chat-btn-root, [class*="whatsapp" i]');
      if (wa) {
        wa.style.setProperty('bottom', 'calc(84px + env(safe-area-inset-bottom, 0px))', 'important');
      }
    }
    adjust();
    window.addEventListener('resize', adjust, { passive: true });
    window.setTimeout(adjust, 1000);
    window.setTimeout(adjust, 2500);
  }

  function init() {
    initWhatsAppOffset();
    initStickyPurchase();
    initCategoryStreams();
    initDetailReadMore();
    initMakingVideoControls();
    initBeddingStoryVideos();
    initProductMobileDots();
    initBeddingAutoRails();
    initReviewsAnchorScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

